import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as formValidation from '@elements/form-validation';
formValidation.init({
    trigger:{event: 'false'}
});

import * as floatingLabels from '@elements/floating-labels';
floatingLabels.init();

import * as datepicker from "@elements/datepicker";
datepicker.init();

import * as datepickerRange from '@elements/datepicker-range';
datepickerRange.init();

import * as dateInput from "@elements/date-input";
dateInput.init();

import * as variableFormFields from "./scripts/variable-form-fields";
variableFormFields.init();

import Tooltip from 'bootstrap/js/dist/tooltip';
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))

